import {
  ColumnHeader,
  OtherAssetType,
  OwnerModelDTO,
  OwnerOptionsDTO,
} from '../../OtherAssets.meta';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';

export const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: 'Value', align: 'right' },
  { text: 'Annual Contribution', align: 'right' },
  { text: 'Distribution Start Age', align: 'right' },
];

export enum DeferredCompensationContributionUnit {
  Dollar,
  Percentage,
}

export enum DeferredCompensationDistributionMethodDTO {
  Auto,
  Custom,
}

export interface CustomDistributionScheduleItemDTO {
  Unit: DeferredCompensationContributionUnit;
  Value: number;
}

export interface DeferredCompensationDTO {
  Id: string;
  Name: string;
  Value: number;
  Owner: string;
  YearlyContribution: number | null;
  ContributionUnit: DeferredCompensationContributionUnit;
  ContributionStartAge: number;
  ContributionEndYear: number | null;
  DistributionStartAge: number | null;
  DistributionPeriod: number;
  AccumulationGrowthRate: number;
  DistributionGrowthRate: number;
  OtherAssetType: OtherAssetType;
  CustomBucketIndex: number | null;
  IsExcludedFromAssetBucketing: boolean;
  IsLiquid: boolean;
  IncludeInGrossEstate: boolean;
  OrionManagementStyleId: number | null;
  DistributionMethod: DeferredCompensationDistributionMethodDTO;
  CustomDistributionSchedule: CustomDistributionScheduleItemDTO[];
  ExcludeFromNetWorth: boolean;
  OwnerModel: OwnerModelDTO[];
}

export interface DeferredCompensationOptionsDTO {
  AllowUnequalOwnership: boolean;
  earner: OwnerOptionsDTO;
  contributionStartAgePrincipal: OptionType<number>[];
  contributionStartAgeSpouse: OptionType<number>[];
  contributionEndYear: OptionType<number | null>[];
  distributionStartAgePrincipal: OptionType<number | null>[];
  distributionStartAgeSpouse: OptionType<number | null>[];
  principalAge: number;
  principalRetirementAge: number;
  principalLifeExpectancy: number;
  spouseAge: number;
  spouseLifeExpectancy: number;
  spouseRetirementAge: number;
  DefaultAssetBucketIndex: number | null;
  IsLiquid: boolean;
}
